var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90991 25.3332V13.3332C5.90991 12.9109 6.00458 12.5109 6.19391 12.1332C6.38325 11.7554 6.64413 11.4443 6.97658 11.1998L14.9766 5.19984C15.4432 4.84428 15.9766 4.6665 16.5766 4.6665C17.1766 4.6665 17.7099 4.84428 18.1766 5.19984L26.1766 11.1998C26.5099 11.4443 26.7712 11.7554 26.9606 12.1332C27.1499 12.5109 27.2441 12.9109 27.2432 13.3332V25.3332C27.2432 26.0665 26.9819 26.6945 26.4592 27.2172C25.9366 27.7398 25.309 28.0007 24.5766 27.9998H20.5766C20.1988 27.9998 19.8824 27.8718 19.6272 27.6158C19.3721 27.3598 19.2441 27.0434 19.2432 26.6665V19.9998C19.2432 19.6221 19.1152 19.3056 18.8592 19.0505C18.6032 18.7954 18.2868 18.6674 17.9099 18.6665H15.2432C14.8655 18.6665 14.549 18.7945 14.2939 19.0505C14.0388 19.3065 13.9108 19.6229 13.9099 19.9998V26.6665C13.9099 27.0443 13.7819 27.3612 13.5259 27.6172C13.2699 27.8732 12.9535 28.0007 12.5766 27.9998H8.57658C7.84325 27.9998 7.21569 27.7389 6.69391 27.2172C6.17213 26.6954 5.9108 26.0674 5.90991 25.3332Z",
    fill: "#4FD1DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/home-filled.981fc5564ddb57018f9b06ec14f7254b.svg";
export { ForwardRef as ReactComponent };